import { Utils } from "@app/_helpers";
import { CardSummaryResponse, MarginBlocked, MarginResponse, MasterTrustMarginResponse, SwastikaMarginResponse, TransactionDetailsResponse, TransactionTable } from "@app/_shared/providers/funds/funds.interface";
import { DashboardDefaultStrategyType } from "@app/_shared/shared.structs";
import * as moment from 'moment';
import { BriefStrategyCache } from "../../../market-place/providers/market-place/market-place.models";
import { Product_Type, TRANSACTION_MODE_ENUM } from "./funds.enums";





export class CardSummary implements CardSummaryResponse {
    cash: number = 0;
    adhoc: number = 0;
    custom_component: number = 0;
    cash_available: number = 0;
    margin_utilized: number = 0;
    product_type: string;
    cardName: string;
    uAlgoCollateral: number = 0;
    aiRecommendationMargin: number = 0;

    constructor(type: string) {
        this.cardName = type;
        this.product_type = Product_Type.Intraday;
    }

    calculateMarginValues(response: MarginResponse) {
        this.cash = response.cash || 0;
        this.adhoc = response.adhoc || 0;
        this.custom_component = response.custom_component + response.collateral || 0;
        this.uAlgoCollateral = response.ualgo_collateral || 0
        this.cash_available = response.cash_available || 0;
        this.margin_utilized = response.margin_utilized || 0;
        this.aiRecommendationMargin = response.cash_available || 0;
    }

    updateMarginValues(response: MarginResponse, deployedMargin: boolean = false){
        this.aiRecommendationMargin += response.adhoc + response.custom_component;
        if(!deployedMargin){
            this.adhoc+=response.adhoc;
            this.custom_component = this.custom_component + response.custom_component - this.uAlgoCollateral;
        } else {
            this.custom_component = this.custom_component - this.uAlgoCollateral;
        }
    }

    calculateSwastikaMarginValues(response: SwastikaMarginResponse) {
        this.cash = response.cash;
        this.adhoc = 0;
        this.custom_component = 0 + response.collateral;
        this.cash_available = response.cash + response.day_cash + response.uncleared_cash + response.payin
         + response.payout + response.collateral - response.margin_used + response.brkcollamt;
        this.margin_utilized = response.margin_used;
    }

    calculateMasterTrustMarginValues(response: MasterTrustMarginResponse) {
        this.cash = response.cash;
        this.adhoc = 0;
        this.custom_component = 0 + response.collateral;
        this.cash_available = response.cash + response.day_cash + response.uncleared_cash + response.payin + response.payout + response.collateral + response.brkcollamt - response.margin_used;
        this.margin_utilized = response.margin_used;
    }
}

export class SwastikaMarginSummary implements SwastikaMarginResponse {
    cash: number;
    day_cash: number;
    uncleared_cash: number;
    payin: number;
    payout: number;
    collateral: number;
    margin_used: number;
    brkcollamt: number;

    constructor(res: SwastikaMarginResponse) {
       this.cash = res.cash ? +res.cash : 0;
       this.day_cash = res.day_cash ? +res.day_cash : 0;
       this.uncleared_cash = res.uncleared_cash ? +res.uncleared_cash : 0;
       this.payin = res.payin ? +res.payin : 0;
       this.payout = res.payout ? +res.payout : 0;
       this.collateral = res.collateral ? +res.collateral : 0;
       this.margin_used = res.margin_used ? +res.margin_used : 0;
       this.brkcollamt = res.brkcollamt ? +res.brkcollamt : 0;
    }

}

export class Transaction implements TransactionTable {
    portfolio_name: string = '';
    product_type: string = Product_Type.Intraday;
    unblocked_on: number;
    blocked_on: number;
    transaction_amount: number;
    creator: string;
    creationMethod: number;
    isBlocked: boolean;
    isOriginals:boolean;
    multiplier: number;

    constructor(transactionResponse: MarginBlocked) {
        this.portfolio_name = transactionResponse.portfolio_id;
        this.blocked_on = moment(transactionResponse.created_at).unix() * 1e3;
        this.unblocked_on = !transactionResponse.is_blocked ? (moment(transactionResponse.updated_at).unix() * 1e3): null;
        this.transaction_amount = transactionResponse.is_blocked ? Utils.applyPrecision(transactionResponse.amount) : Utils.applyPrecision(transactionResponse.unblock_amount);
        this.creator = transactionResponse.client_id;
        this.isBlocked = transactionResponse.is_blocked;
        this.multiplier = transactionResponse.multiplier;


        this.updateAlgoName(transactionResponse.portfolio_id);
    }

    updateAlgoName(portfolio_id: string) {
        const portfolio = BriefStrategyCache.Instance.getPortfolioByID(portfolio_id);
        if (portfolio) {
            this.portfolio_name = portfolio.portfolioName;
            this.isOriginals = portfolio.isPublic && (portfolio.verficationStatus === DashboardDefaultStrategyType.ORIGINALS);
        }
    }
}

export class TransactionDetail implements TransactionDetailsResponse {
    amount: number;
    bank_name: string;
    last_updated_time: number;
    mode: string;
    payment_gateway: string;
    start_time: number;
    status: string;
    ut_transaction_id: string;

    constructor(transactionDetailResponse: TransactionDetailsResponse) {

        this.amount = transactionDetailResponse.amount;
        this.bank_name = transactionDetailResponse.bank_name;
        this.last_updated_time = transactionDetailResponse.last_updated_time;
        this.mode = transactionDetailResponse.mode;
        this.payment_gateway = transactionDetailResponse.payment_gateway;
        this.start_time = transactionDetailResponse.start_time;
        this.status = transactionDetailResponse.status;
        this.ut_transaction_id = transactionDetailResponse.ut_transaction_id;
    }
}


export const defaultTransactionParams = {
    mode: TRANSACTION_MODE_ENUM.ALL,
    startDate: moment().subtract(7, 'days').startOf('day').toDate(),
    endDate: moment().startOf('day').toDate(),
};
